const Services = () => {
  const services = [
    {
      id: 'consulting',
      title: 'Consulting',
      description: 'Strategic guidance to help cultural institutions navigate digital transformation and technology decisions.',
      features: [
        'Digital strategy development for GLAM institutions',
        'Technology assessment and vendor evaluation',
        'Collection digitization planning and roadmaps',
        'Data architecture and infrastructure design',
        'Change management and staff training strategies',
        'Grant writing support for technology initiatives'
      ]
    },
    {
      id: 'software-design',
      title: 'Software Design',
      description: 'User-centered design of digital platforms that serve both institutional needs and public engagement.',
      features: [
        'User experience research and design for cultural applications',
        'Interface design for collection discovery and exploration',
        'Accessibility-first design for inclusive access',
        'Mobile-responsive design for diverse audiences',
        'Information architecture for complex cultural data',
        'Design system development for consistent experiences'
      ]
    },
    {
      id: 'prototyping',
      title: 'Prototyping',
      description: 'Rapid development of proof-of-concept solutions to validate ideas before full implementation.',
      features: [
        'Interactive wireframes and mockups',
        'Functional prototypes for user testing',
        'API integration experiments and demonstrations',
        'Data visualization and dashboard prototypes',
        'AI/ML model testing and validation',
        'Technology feasibility studies and demonstrations'
      ]
    },
    {
      id: 'custom-development',
      title: 'Custom Development',
      description: 'Full-scale development of tailored software solutions for cultural heritage institutions.',
      features: [
        'Custom web applications and digital platforms',
        'API development and third-party integrations',
        'Database design and data migration services',
        'AI-powered search and discovery systems',
        'Content management and workflow tools',
        'Performance optimization and scalability solutions'
      ]
    },
    {
      id: 'training',
      title: 'Training',
      description: 'Comprehensive training programs to help staff maximize the value of their digital systems.',
      features: [
        'Platform-specific training for administrators and users',
        'Digital literacy workshops for cultural professionals',
        'Data management best practices training',
        'AI and machine learning concepts for non-technical staff',
        'Ongoing support and knowledge transfer programs',
        'Train-the-trainer programs for institutional sustainability'
      ]
    }
  ];

  return (
    <div>
      <div className="max-w-4xl mx-auto mb-12">
        <h1 className="text-4xl font-bold mb-6">Our Services</h1>
        <p className="text-lg text-glam-secondary dark:text-gray-300">
          We offer comprehensive solutions designed specifically for galleries, libraries, 
          archives, and museums. Our services combine deep domain expertise with cutting-edge 
          technology to help you preserve, organize, and share your cultural heritage.
        </p>
      </div>

      <div className="space-y-16">
        {services.map((service) => (
          <section key={service.id} id={service.id} className="scroll-mt-20">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-3xl font-bold mb-4">{service.title}</h2>
              <p className="text-lg text-glam-secondary dark:text-gray-300 mb-8">
                {service.description}
              </p>
              <div className="bg-glam-light dark:bg-gray-900 rounded-lg p-8">
                <h3 className="text-xl font-semibold mb-4">Key Features</h3>
                <ul className="space-y-3">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <svg 
                        className="w-6 h-6 text-glam-accent mr-3 mt-0.5 flex-shrink-0" 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path 
                          strokeLinecap="round" 
                          strokeLinejoin="round" 
                          strokeWidth={2} 
                          d="M5 13l4 4L19 7" 
                        />
                      </svg>
                      <span className="text-glam-secondary dark:text-gray-300">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        ))}
      </div>

      <section className="mt-16 max-w-4xl mx-auto">
        <div className="bg-glam-accent text-white rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold mb-4">
            Custom Solutions for Your Institution
          </h2>
          <p className="mb-6">
            Every collection is unique. We work closely with you to design solutions 
            that meet your specific needs, timeline, and budget.
          </p>
          <a
            href="/contact"
            className="inline-block px-6 py-3 bg-white text-glam-accent rounded-lg hover:bg-gray-100 transition-colors font-semibold"
          >
            Discuss Your Project
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;